module.exports = __webpack_public_path__ + "static/media/vertical_option_tablet.23c2699a.jpg";